
  var _styles = {
  "comprehensive-card-button-container": {
    "marginTop": "0.37333rem"
  },
  "comprehensive-card-button-bg": {
    "width": "5.89333rem",
    "height": "0.8rem"
  },
  "comprehensive-card-button-text-container": {
    "position": "absolute",
    "width": "5.89333rem",
    "height": "0.8rem",
    "display": "flex",
    "alignItems": "center",
    "flexDirection": "row",
    "paddingLeft": "0.28rem",
    "paddingRight": "0.28rem"
  },
  "comprehensive-card-button-RMB": {
    "marginTop": "0.16rem",
    "fontWeight": "400",
    "fontFamily": "MTfin-Regular2.0",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "textAlign": "right",
    "lineHeight": "0.29333rem"
  },
  "comprehensive-card-button-actual-price": {
    "fontWeight": "400",
    "fontFamily": "MTfin-Regular2.0",
    "fontSize": "0.48rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "textAlign": "right",
    "lineHeight": "0.53333rem"
  },
  "comprehensive-card-button-char-qi": {
    "marginTop": "0.2rem",
    "marginLeft": "0.06667rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.24rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "lineHeight": "0.26667rem"
  },
  "comprehensive-card-button-original-price": {
    "marginLeft": "0.09333rem",
    "marginTop": "0.24rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "letterSpacing": 0,
    "lineHeight": "0.29333rem",
    "textDecoration": "line-through",
    "WebkitTextDecorationColor": "#fff",
    "textDecorationColor": "#fff"
  },
  "comprehensive-card-button-reduced-price-container": {
    "marginLeft": "0.08rem",
    "background": "#ffe1a3",
    "borderRadius": "0.2rem 0.2rem 0.2rem 0.02667rem"
  },
  "comprehensive-card-button-reduced-price": {
    "marginTop": "0.06667rem",
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.26667rem",
    "color": "rgb(255,65,0)",
    "letterSpacing": 0,
    "lineHeight": "0.29333rem",
    "paddingTop": "0.05333rem",
    "paddingRight": "0.10667rem",
    "paddingBottom": "0.05333rem",
    "paddingLeft": "0.10667rem"
  },
  "comprehensive-card-button-buy": {
    "marginLeft": "auto",
    "marginTop": "0.06667rem",
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.37333rem",
    "color": "rgb(142,60,18)",
    "letterSpacing": 0,
    "textAlign": "center",
    "lineHeight": "0.42667rem"
  }
};



  module.exports = _styles;
  